import { createContext } from 'react'

const HierarchyItemsContext = createContext({ store: null })

export default HierarchyItemsContext
